/**
 * @todo When connecting the real backend, just change this file to the correct
 * end points.
 */

const ENDPOINT = new Map();
ENDPOINT.set('courseClasses', '/course/classes/get');
ENDPOINT.set('markViewed', '/course/class/view');

export default ENDPOINT